/**
 * Ссылка «Передай соседу» (план 21.09, уровень 0): рядом стоящий человек
 * сканирует ЭКРАН — и аварийный режим открывается у него, даже если сети у
 * него нет (кадр целиком лежит в самой ссылке, ADR 0004 §URL-контракт).
 *
 * Подпись кадра ПЕРЕИСПОЛЬЗУЕТСЯ как есть: мы не перепод­писываем и не
 * продлеваем TTL — сосед получает ровно тот кадр, который проверил наш
 * verify, с тем же `expires`. Учения подписи не имеют вовсе, поэтому для них
 * ссылка идёт коротким путём `?drill=<hazard>` (анти-паника: демонстрация
 * остаётся демонстрацией и на чужом телефоне).
 */
import type { DrillHazard } from './drill'
import { type EmergencyFrame, encodeFrame, frameToParam } from './frame'

/** Сценарий учений по умолчанию, если тип опасности почему-то не известен. */
const DRILL_FALLBACK: DrillHazard = 'evac'

/**
 * Ссылка на аварийный режим для соседа.
 * `origin` — `location.origin` (в тестах любой), `drill` — сценарий учений
 * (не null ⇒ ссылка учебная, без подписи).
 */
export function buildPassLink(
  origin: string,
  frame: EmergencyFrame,
  drill: DrillHazard | null,
): string {
  const venueUrl = `${origin}/v/${encodeURIComponent(frame.venue)}`
  if (drill !== null) return `${venueUrl}?drill=${drill}`
  return `${venueUrl}?e=${frameToParam(encodeFrame(frame, frame.sig))}`
}

/** Сценарий для учебной ссылки: тип опасности или безопасный запасной. */
export function passDrillHazard(isDrill: boolean, hazard: DrillHazard | null): DrillHazard | null {
  if (!isDrill) return null
  return hazard ?? DRILL_FALLBACK
}
